import type { MenuItemType } from '@atlaskit/editor-ui-control-model/types';

export const BACKGROUND_COLOR_ITEM: MenuItemType = {
	type: 'menu-item',
	key: 'background-color',
};

export const CLEAR_CELLS_ITEM: MenuItemType = {
	type: 'menu-item',
	key: 'clear-cells',
};
